module.exports = __webpack_public_path__ + "static/media/sort-tags.735b1c3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FAQ/assets/sort-tags.png
// module id = 927
// module chunks = 0